module.exports = __webpack_public_path__ + "static/media/downloads.bf160198.csv";